import { Component } from '@angular/core';
import { LEGAL_INFO } from '../legal-info';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['../legal.scss'],
    standalone: false
})
export class PrivacyComponent {
  info = LEGAL_INFO;
}
